/**
 * Modelo de permissoes por modulo do dashboard.
 * Replica o ModuloDePermissao do mobile (modulo_de_permissao_model.dart).
 * Alinhado 1:1 com o mobile.
 */
export interface ModuloPermissaoDashboard {
  // 11 campos originais
  pontoDeVenda: boolean;
  compra: boolean;
  produto: boolean;
  funcionario: boolean;
  cliente: boolean;
  fornecedor: boolean;
  configuracao: boolean;
  conta: boolean;
  gastos: boolean;
  receitas: boolean;
  dashboard: boolean;
  // 12 campos novos (alinhados com mobile)
  cupom: boolean;
  estoqueLimitado: boolean;
  extratoConta: boolean;
  resumoConta: boolean;
  unidade: boolean;
  marca: boolean;
  grupo: boolean;
  subgrupo: boolean;
  funcaoFuncionario: boolean;
  transferencias: boolean;
  cancelarNota: boolean;
  cancelarMovimento: boolean;
  gestaoDePedidos: boolean;
  configuracaoMinishop: boolean;
  // 2 novos privilegios (alinhados com mobile: indicacoes / gestaoContador)
  indicacoes: boolean;
  gestaoContador: boolean;
  // Janelas proprias da aba Ajustes (backend V1.125): antes delas planos, dados
  // de cobranca e timbrado entravam por `configuracao` e privilegios por
  // `funcionario`. `impressoras` existe so no mobile, mas fica aqui para o
  // modelo continuar 1:1 com o do app.
  planos: boolean;
  dadosDeCobranca: boolean;
  timbrado: boolean;
  impressoras: boolean;
  privilegios: boolean;
  // Aba Informes (backend V1.126): uma janela por relatorio. Antes delas cada
  // relatorio herdava o privilegio do modulo de origem.
  relatorioVendas: boolean;
  relatorioItensVendidos: boolean;
  relatorioListaItens: boolean;
  relatorioExtratoDeCaixa: boolean;
  relatorioContasPagas: boolean;
  relatorioContasAPagar: boolean;
  relatorioContasRecebidas: boolean;
  relatorioContasAReceber: boolean;
  relatorioDre: boolean;
  // Janelas separadas na V1.127 do backend (o mobile ja as usa). Antes delas a
  // lista de pedidos entrava por `gestaoDePedidos` — a mesma janela das
  // operacoes do card — e as carteiras entravam por `gastos` e `receitas`, as
  // janelas de lancar despesa e receita. Com elas da para dar consulta sem dar
  // operacao.
  visualizarPedidos: boolean;
  contasAPagar: boolean;
  contasAReceber: boolean;
}

export const PERMISSAO_TOTAL: ModuloPermissaoDashboard = {
  pontoDeVenda: true,
  compra: true,
  produto: true,
  funcionario: true,
  cliente: true,
  fornecedor: true,
  configuracao: true,
  conta: true,
  gastos: true,
  receitas: true,
  dashboard: true,
  cupom: true,
  estoqueLimitado: true,
  extratoConta: true,
  resumoConta: true,
  unidade: true,
  marca: true,
  grupo: true,
  subgrupo: true,
  funcaoFuncionario: true,
  transferencias: true,
  cancelarNota: true,
  cancelarMovimento: true,
  gestaoDePedidos: true,
  configuracaoMinishop: true,
  indicacoes: true,
  gestaoContador: true,
  planos: true,
  dadosDeCobranca: true,
  timbrado: true,
  impressoras: true,
  privilegios: true,
  relatorioVendas: true,
  relatorioItensVendidos: true,
  relatorioListaItens: true,
  relatorioExtratoDeCaixa: true,
  relatorioContasPagas: true,
  relatorioContasAPagar: true,
  relatorioContasRecebidas: true,
  relatorioContasAReceber: true,
  relatorioDre: true,
  visualizarPedidos: true,
  contasAPagar: true,
  contasAReceber: true,
};

export const SEM_PERMISSAO: ModuloPermissaoDashboard = {
  pontoDeVenda: false,
  compra: false,
  produto: false,
  funcionario: false,
  cliente: false,
  fornecedor: false,
  configuracao: false,
  conta: false,
  gastos: false,
  receitas: false,
  dashboard: false,
  cupom: false,
  estoqueLimitado: false,
  extratoConta: false,
  resumoConta: false,
  unidade: false,
  marca: false,
  grupo: false,
  subgrupo: false,
  funcaoFuncionario: false,
  transferencias: false,
  cancelarNota: false,
  cancelarMovimento: false,
  gestaoDePedidos: false,
  configuracaoMinishop: false,
  indicacoes: false,
  gestaoContador: false,
  planos: false,
  dadosDeCobranca: false,
  timbrado: false,
  impressoras: false,
  privilegios: false,
  relatorioVendas: false,
  relatorioItensVendidos: false,
  relatorioListaItens: false,
  relatorioExtratoDeCaixa: false,
  relatorioContasPagas: false,
  relatorioContasAPagar: false,
  relatorioContasRecebidas: false,
  relatorioContasAReceber: false,
  relatorioDre: false,
  visualizarPedidos: false,
  contasAPagar: false,
  contasAReceber: false,
};
